// Angular dependencies.
import {
  Component,
  OnInit
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

// App dependencies.
import {
  CreepType,
  CREEP_OPERATOR,
  CREEP_COMMANDER,
  CREEP_EXECUTOR
} from '../creep/creep.enum';
import { Creep } from '../creep/creep';

// Store
import { State } from '@ngrx/store';
import { AppState } from '../store.module';

@Component({
  selector: 'app-page-creep',
  templateUrl: './page-creep.component.html',
  styleUrls: ['./page-creep.component.scss']
})
export class PageCreepComponent implements OnInit {
  public CREEP_OPERATOR: CreepType = CREEP_OPERATOR;
  public CREEP_COMMANDER: CreepType = CREEP_COMMANDER;
  public CREEP_EXECUTOR: CreepType = CREEP_EXECUTOR;

  creep: Creep;

  constructor(
    private _state: State<AppState>,
    private _route: ActivatedRoute,
    private _router: Router
  ) {

    const _id = this._state.getValue().creeps.creeps.length + '';

    this.creep = new Creep(_id);
  }

  ngOnInit() {
    this._route
      .queryParams
      .map(({ edit }) => edit)
      .filter((_) => _)
      .map((edit) => Creep.fromString(edit))
      .do((creep) => this.creep = creep)
      .subscribe();
  }

  setType(type: CreepType) {
    this.creep.type = type;

    this._router.navigate([`creep/levels`], {
      queryParams: {
        'edit': this.creep.toString(),
        'creeps': this._route.snapshot.queryParams['creeps']
      }
    });
  }

  onChange() {
    this._router.navigate(['.'], {
      queryParams: {
        'edit': this.creep.toString(),
        'creeps': this._route.snapshot.queryParams['creeps']
      },
      relativeTo: this._route,
      replaceUrl: true
    });
  }
}



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/page-creep.module/page-creep.component.ts